<p>attachments works!</p>
